import {
  CpBody01Primary,
  CpBody02Primary,
  CpBody03Primary,
  CpHeading01Primary,
  CpHeading02Primary,
  CpHeading03Primary,
  CpHeading04Primary,
} from 'components/atoms/customer-portal/typography';

export const CpHeading04 = CpHeading04Primary;
export const CpHeading03 = CpHeading03Primary;
export const CpHeading02 = CpHeading02Primary;
export const CpHeading01 = CpHeading01Primary;

export const CpParaLarge = CpBody03Primary;
export const CpParaMedium = CpBody02Primary;
export const CpParaRegular = CpBody01Primary;
